import { Component, inject } from '@angular/core';
import { HeaderComponent } from './layout/header/header.component';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from './layout/footer/footer.component';
import { UserInfoService } from '@core/services/user-info.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.html',
    imports: [HeaderComponent, RouterOutlet, FooterComponent]
})
export class AppComponent {
    private userInfo = inject(UserInfoService);

    ngOnInit() {
        this.userInfo.authorize();
    }
}
